<script>
import { colors } from '@/config'

import getShiftedColor from '@/util/getShiftedColor'

export default {

  props: {
    node: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      specialNodeColor: getShiftedColor(colors.white),
      defaultColor: getShiftedColor(colors.darkBrown),
      highlightColor: getShiftedColor(colors.brown)
    }
  },

  computed: {

    isStartNode () {
      return this.node.id === this.$store.getters.currentLevelStartNodeId
    },

    isGoalNode () {
      return this.node.id === this.$store.getters.currentLevelGoalNodeId
    },

    hasCursor () {
      return this.node.id === this.$store.getters.cursorNodeId
    },

    hasPlayer () {
      return this.node.id === this.$store.getters.playerNodeId
    },

    color () {

      if (this.isStartNode || this.isGoalNode) {
        return this.specialNodeColor
      }

      if (this.hasCursor && !this.hasPlayer) {
        return this.highlightColor
      }

      return this.defaultColor
    }

  }

}
</script>

<template>
  <a-entity
    geometry="width: 1; height: 1; depth: 2;"
    material="visible: false"
  >
    <a-cylinder
      :color="color"
      :height="0.1"
      :radius="0.25"
      rotation="90 0 0"
      position="0 0 -0.95"
    />
  </a-entity>
</template>
